// extracted by mini-css-extract-plugin
export default {"label":"VBInputLabel_label__sGHUT","noMargin":"VBInputLabel_noMargin__nDMJs","required":"VBInputLabel_required__0Xy9s"};